import { render } from "./ListaEmpresas.vue?vue&type=template&id=4267ad01"
import script from "./ListaEmpresas.vue?vue&type=script&lang=js"
export * from "./ListaEmpresas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__